module.exports = __webpack_public_path__ + "img/painter.f497ac7d.jpg";